import { normalizeRecurrenceId } from './eventRecurrence.js';
export const jamRoomName = (postId, _recurrenceId) => postId;
const UUID_PREFIX = /^([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})(?:_.*)?$/i;
export const postIdFromJamRoomName = (roomName) => {
    var _a;
    const match = roomName.match(UUID_PREFIX);
    return (_a = match === null || match === void 0 ? void 0 : match[1]) !== null && _a !== void 0 ? _a : roomName;
};
/** Recurring jams use one LiveKit room per event; leftover occurrence rooms still collapse. */
export const uniquePostsById = (posts) => {
    const seen = new Set();
    const unique = [];
    for (const post of posts) {
        if (!post || seen.has(post.id))
            continue;
        seen.add(post.id);
        unique.push(post);
    }
    return unique;
};
export const getJamUrl = (id, origin, occurrence) => {
    if (!id) {
        return '';
    }
    const query = occurrence
        ? `?occurrence=${encodeURIComponent(normalizeRecurrenceId(occurrence))}`
        : '';
    if (!origin)
        return `/events/${id}/jam${query}`;
    return `${origin}/events/${id}/jam${query}`;
};
export const jamFromEvent = (event) => {
    var _a, _b;
    if (((_a = event.data) === null || _a === void 0 ? void 0 : _a.type) === 'event' && ((_b = event.data) === null || _b === void 0 ? void 0 : _b.jam)) {
        return event.data.jam;
    }
    return undefined;
};
export const canModerateJam = (profile, post) => { var _a, _b; return !!(profile && ((_b = (_a = jamFromEvent(post)) === null || _a === void 0 ? void 0 : _a.moderators) === null || _b === void 0 ? void 0 : _b.includes(profile.id))); };
export const canAccessJamRecordings = (profile, post) => {
    var _a, _b, _c, _d;
    if (!profile) {
        return false;
    }
    if (post.profile.id === profile.id) {
        return true;
    }
    if (((_a = post.data) === null || _a === void 0 ? void 0 : _a.type) !== 'event') {
        return false;
    }
    const event = post.data;
    if ((_b = event.moderators) === null || _b === void 0 ? void 0 : _b.includes(profile.id)) {
        return true;
    }
    return !!((_d = (_c = event.jam) === null || _c === void 0 ? void 0 : _c.moderators) === null || _d === void 0 ? void 0 : _d.includes(profile.id));
};
export const isRtmpJamRecording = (recording) => recording.kind === 'rtmp';
export const isFileJamRecording = (recording) => !isRtmpJamRecording(recording);
export const pickActiveFileRecording = (recordings) => recordings.find(isFileJamRecording);
export const pickActiveRtmpStream = (recordings) => recordings.find(isRtmpJamRecording);
export const assembleRtmpUrl = (url, streamKey) => {
    const base = url.trim().replace(/\/+$/, '');
    const key = streamKey.trim().replace(/^\/+/, '');
    if (!base || !key) {
        return undefined;
    }
    if (!/^rtmps?:\/\//i.test(base)) {
        return undefined;
    }
    return `${base}/${key}`;
};
export const rtmpDestinationHost = (rtmpUrl) => {
    try {
        return new URL(rtmpUrl).hostname || undefined;
    }
    catch {
        return undefined;
    }
};
export const toRtmpStreamResponse = (recording) => ({
    id: recording.id,
    status: recording.status,
    destinationHost: recording.destinationHost,
    egressId: recording.egressId,
});
